import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Attach token to every request
API.interceptors.request.use(config => {
  const token = localStorage.getItem('nfl_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Handle 401 globally — but only the kind that means "your session died".
 *
 * A wrong password is also a 401, and this used to bounce it to `/` like any
 * other. The reload tore down the login page before React could render the
 * error, so a mistyped password looked like nothing happening at all: the form
 * blanked and no message ever appeared. Two guards, because either alone leaves
 * a hole — a stale token in storage would still hijack a failed sign-in, and a
 * 401 from some other call with no token should not silently reload the page.
 */
API.interceptors.response.use(
  res => res,
  err => {
    const url = String(err.config?.url || '');
    const isSignInAttempt = url.includes('/auth/login') || url.includes('/auth/register');
    const hadSession = !!localStorage.getItem('nfl_token');
    if (err.response?.status === 401 && hadSession && !isSignInAttempt) {
      localStorage.removeItem('nfl_token');
      localStorage.removeItem('nfl_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default API;
